import type { MapLayerKey } from '../../services/map-layer-selection.service';

export interface MapLayerTile {
  key: MapLayerKey;
  label: string;
  icon: string;
}

/** Catch heat leads in Flutter's strip (the reason most captains open it); fleet-gated. */
export const HEAT_TILE: MapLayerTile = { key: 'catch', label: 'Heatmap', icon: '/assets/home/overlay/catch_heat_layer.png' };

/** The six ocean fields (Flutter's "Overlays" group). */
export const FIELD_TILES: MapLayerTile[] = [
  { key: 'sst', label: 'SST', icon: '/assets/home/overlay/sst_layer.png' },
  { key: 'chl', label: 'Chlorophyll', icon: '/assets/home/overlay/chlorophyll_layer.png' },
  { key: 'wind', label: 'Wind', icon: '/assets/home/overlay/wind_layer.png' },
  { key: 'sss', label: 'Salinity', icon: '/assets/home/overlay/salinity_layer.png' },
  { key: 'cur', label: 'Currents', icon: '/assets/home/overlay/currents_layer.png' },
  { key: 'fsle', label: 'FSLE', icon: '/assets/home/overlay/fsle_layer.png' },
];

/** The marker overlays (Flutter's "Layers" group). */
export const PIN_TILES: MapLayerTile[] = [
  { key: 'buoy', label: 'Buoy', icon: '/assets/home/layer/buoy_overlay 1.png' },
  { key: 'local-tides', label: 'Local Tides', icon: '/assets/home/layer/tide_overlay 1.png' },
  { key: 'wrecks', label: 'Wrecks', icon: '/assets/home/layer/wrecks_logo.svg' },
];
